import * as React from "react";
import clsx from "clsx";
import { Spinner } from "../spinner/spinner.mjs";
const Overlay = (props) => {
  const { className, type, spinner } = props;
  const getSpinner = () => {
    if (typeof spinner === "object" && spinner !== null) {
      return /* @__PURE__ */ React.createElement(Spinner, { ...spinner, className: clsx("overlay__spinner", spinner.className) });
    } else if (spinner) {
      return /* @__PURE__ */ React.createElement(Spinner, { className: "overlay__spinner" });
    }
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: clsx(
        "overlay",
        {
          ["overlay--".concat(type)]: !!type
        },
        className
      )
    },
    getSpinner()
  );
};
export {
  Overlay
};
